import React, { useEffect, useState } from 'react';
import { useIntl } from 'react-intl';
import { LogoLink, LogoWrapper, LogoImage } from './styled';

const LogoComponent = () => {
  const { locale, messages } = useIntl();
  const [hasScrolled, setHasScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      if (!hasScrolled) {
        setHasScrolled(true);
        window.removeEventListener('scroll', handleScroll);
      }
    };

    window.addEventListener('scroll', handleScroll);

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, [hasScrolled]);

  const href =
    locale === 'en'
      ? 'https://www.bitcoin.com/'
      : `https://www.bitcoin.com/${locale}/`;

  return (
    <LogoLink href={href}>
      <LogoWrapper>
        <LogoImage
          src={messages['home.navbarhome.logoImage.src']}
          alt={messages['home.navbarhome.logoImage.alt']}
        />
      </LogoWrapper>
    </LogoLink>
  );
};

export default LogoComponent;
